import React from "react";
import { useUnitsSettingsVM } from "./UnitsSettingsViewModel";
import UnitsSettingsView from "./UnitsSettingsView";

interface Props {
  loggedState: number;
  loggedID: string;
}

const UnitsSettings: React.FC<Props> = (props) => {
  const vm = useUnitsSettingsVM(props.loggedID);

  return (
    <UnitsSettingsView
      loggedState={props.loggedState}
      state={vm.state}
      actions={vm.actions}
    />
  );
};

export default UnitsSettings;